<template>
  <div>
    <div class="container">
      <div class="handle-box">
        <el-button
          type="primary"
          icon="el-icon-lx-down"
          class="handle-down mr10"
          @click="downloadStudiosFile"
          >下载模板文件</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-lx-add"
          class="handle-add mr10"
          @click="isBatchAddShow = true"
          >批量创建工作室及其医生</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-lx-add"
          class="handle-add mr10"
          @click="addStudioBtn"
          >新建工作室</el-button
        >
        <!-- <el-select
          v-model="studio_id"
          class="handle-select mr10"
          @change="selectHandle"
          v-show="select_arr.length > 0"
        >
          <el-option
            v-for="(child, index) in select_arr"
            :key="index"
            :label="child.name"
            :value="child.id"
          ></el-option>
        </el-select> -->
        <el-input
          v-model="keywords"
          placeholder="请输入姓名、医院"
          class="handle-input mr10"
        ></el-input>
        <el-button
          type="primary"
          icon="el-icon-search"
          class="mr10"
          @click="getinit"
          >搜索</el-button
        >
        <!-- <el-button
          type="primary"
          icon="el-icon-lx-down"
          class="handle-down fr"
          @click="exportdoctorlist"
        >导出医生信息</el-button> -->
      </div>
      <el-table
        :data="studiosArr"
        border
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
        v-loading="loading"
      >
        <el-table-column label="序号" align="center">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 + page_index }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="名字"
          align="center"
        ></el-table-column>
        <el-table-column prop="avatar" label="头像" align="center">
          <template slot-scope="scope">
            <el-image
              class="table-td-thumb"
              v-if="scope.row.avatar"
              :src="scope.row.avatar"
              :preview-src-list="[scope.row.avatar]"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="studioDoctorlist(scope.row.id)"
              >工作室医生</el-button
            >
            <el-button type="text" @click="studioDetails(scope.row, 1)"
              >详情</el-button
            >
            <el-button type="text" @click="studioDetails(scope.row, 2)"
              >修改</el-button
            >
            <el-button type="text" @click="deleteStudio(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination" v-if="totalPages > 1">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="currentPage"
          :page-size="10"
          :page-count="totalPages"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>

      <!-- 工作室详情弹出框 -->
      <el-dialog
        width="60%"
        :visible.sync="isDetailShow"
        :close-on-click-modal="false"
      >
        <el-form :model="studioDetailArr" label-width="160px">
          <el-form-item label="名称：">
            <span class="fc mr10">{{ studioDetailArr.name }}</span>
          </el-form-item>

          <el-form-item label="头像：">
            <el-image
              class="look-thumb"
              :src="studioDetailArr.avatar"
              :preview-src-list="[studioDetailArr.avatar]"
            ></el-image>
          </el-form-item>

          <el-form-item label="简介：">
            <span class="fc mr10">{{ studioDetailArr.introduce }}</span>
          </el-form-item>

          <el-form-item label="成立时间：">
            <span class="fc mr10">{{
              formatDate(studioDetailArr.built_up_date)
            }}</span>
          </el-form-item>
        </el-form>
      </el-dialog>

      <!-- 工作室编辑弹出框 -->
      <el-dialog
        width="60%"
        :visible.sync="isModifyShow"
        :close-on-click-modal="false"
      >
        <el-form :model="studioModifyArr" label-width="160px">
          <el-form-item label="名称：">
            <el-input
              v-model="studioModifyArr.name"
              @input="onInput()"
              class="handle-input mr10"
            ></el-input>
          </el-form-item>

          <el-form-item label="头像：">
            <el-upload
              class="avatar-uploader"
              action
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
            >
              <img
                v-show="studioModifyArr.avatar"
                :src="studioModifyArr.avatar"
                class="avatar"
                alt="暂未上传"
              />
              <em
                v-show="!studioModifyArr.avatar && !uploading"
                class="el-icon-plus avatar-uploader-icon"
              ></em>
              <em
                class="el-icon-loading avatar-uploader-icon"
                v-show="uploading"
              ></em>
            </el-upload>
          </el-form-item>
          <el-form-item label="简介：">
            <el-input
              type="textarea"
              v-model="studioModifyArr.introduce"
              @input="onInput()"
              class="handle-input2 mr10"
            ></el-input>
          </el-form-item>

          <el-form-item label="成立时间：">
            <el-date-picker
              v-model="studioModifyArr.built_up_date"
              type="datetime"
              placeholder="选择日期时间"
            >
            </el-date-picker>
          </el-form-item>
          <span class="dialog-footer self-dialog-footer" v-show="isPut">
            <el-button type="primary" @click="putStudioDetails"
              >提 交</el-button
            >
          </span>
          <span class="dialog-footer self-dialog-footer" v-show="!isPut">
            <el-button type="primary" @click="addStudio">提 交</el-button>
          </span>
        </el-form>
      </el-dialog>
      <!-- 工作室医生详情弹出框 -->
      <el-dialog
        :visible.sync="isStudioDoctorShow"
        width="80%"
        :close-on-click-modal="false"
      >
        <div class="handle-box">
          <el-button
            type="primary"
            icon="el-icon-lx-add"
            class="handle-del mr10"
            @click="addStudioDoctorlist"
            >新增工作室医生</el-button
          >
          <el-button type="primary" @click="saveSortData()">保存排序</el-button>
        </div>
        <el-table
          :data="studioDoctorArr"
          border
          class="table"
          row-key="id"
          ref="windowMultipleTable"
          header-cell-class-name="table-header"
          v-loading="doc_loading"
        >
          <el-table-column
            prop="name"
            label="姓名"
            align="center"
          ></el-table-column>
          <el-table-column label="头像" align="center">
            <template>
              <el-image
                class="look-thumb"
                :src="studioDoctorArr.avatar"
                :preview-src-list="[studioDoctorArr.avatar]"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column
            prop="department"
            label="科室"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="title"
            label="职称"
            align="center"
          ></el-table-column>
          <el-table-column label="签约状态" align="center">
            <template slot-scope="scope">
              <span class="fc mr10" v-show="scope.row.is_sign == 1">是</span>
              <span class="fc mr10" v-show="scope.row.is_sign == 0">否</span>
            </template>
          </el-table-column>
          <el-table-column label="账号状态" align="center">
            <template slot-scope="scope">
              <span class="fc mr10" v-if="scope.row.type == 1">正常</span>
              <span class="fc mr10" v-else-if="scope.row.type == 2"
                >被封禁</span
              >
              <span class="fc mr10" v-else-if="scope.row.type == 3"
                >未设置服务价格</span
              >
            </template>
          </el-table-column>

          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-delete"
                @click="deleteStudioDoctor(scope.row.id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination" v-if="docTotalPages > 1">
          <el-pagination
            background
            layout="prev, pager, next"
            :current-page="docCurrentPage"
            :page-size="10"
            :total="docTotalPages"
            @current-change="docHandlePageChange"
          ></el-pagination>
        </div>
      </el-dialog>
      <!-- 新增医生弹出框 -->
      <el-dialog
        width="60%"
        :visible.sync="isdocAddShow"
        :close-on-click-modal="false"
      >
        <div style="width:100%;display: flex;align-items: center;">
          <el-input
            v-model="searchKeywords"
            placeholder="请输入姓名、手机号"
            class="handle-input mr10"
            style="margin-bottom: 10px;"
          ></el-input>
          <el-button
            type="primary"
            @click="searchStudioDoctor"
            style="margin-bottom: 10px;"
            >查询</el-button
          >
        </div>

        <el-table
          :data="studioDoctorTableData"
          border
          class="table"
          row-key="id"
          ref="windowMultipleTable"
          header-cell-class-name="table-header"
          highlight-current-row
          v-loading="doc_loading"
          @current-change="handleCurrentChange"
        >
          <el-table-column
            prop="name"
            label="姓名"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="phone"
            label="手机号"
            align="center"
          ></el-table-column>
        </el-table>
        <span class="dialog-footer self-dialog-footer">
          <el-button style="margin-top: 10px;" type="primary" @click="addStudioDoctor">新增</el-button>
        </span>
      </el-dialog>

      <el-dialog
        :visible.sync="isBatchAddShow"
        width="50%"
        :close-on-click-modal="false"
      >
        <el-form ref="ruleForm" label-width="120px">
          <el-form-item label="使用说明：">
            <p>1.下载模板文件并解压;</p>
            <p>
              2.在 studio/studio.xlsx 文件内填写工作室信息，studio/doctors.xlsx
              文件内填写医生信息，如果有图片需要上传的，将图片放入
              studio/picturs文件下，excel表格中填写该图片的名称；
            </p>
            <p>3.填写完成后将studio重新压缩成zip包并上传。</p>
          </el-form-item>
          <el-form-item label="上传：">
            <el-upload
              class="avatar-uploader"
              action
              :show-file-list="false"
              :before-upload="batchCreationStudios"
            >
              <em
                v-show="!uploading"
                class="el-icon-plus avatar-uploader-icon"
              ></em>
              <em
                class="el-icon-loading avatar-uploader-icon"
                v-show="uploading"
              ></em>
            </el-upload>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
// import { _ } from "vue-underscore";
import http from "../../../api/iapetusApiConfig";
import http2 from "../../../api/uploadApiConfig";
import Sortable from "sortablejs";
export default {
  name: "Doctorlist",
  data() {
    return {
      // 工作室
      studiosArr: [],
      currentPage: 1,
      totalPages: 0,
      page_index: 0,
      loading: false,
      keywords: "",
      studioDoctorTableData: [],
      searchKeywords: "",
      isDetailShow: false,
      studioDetailArr: [],
      isModifyShow: false,
      studioModifyArr: [],
      uploading: false,
      isPut: true,
      //   医生
      doc_loading: false,
      isStudioDoctorShow: false,
      studioDoctorArr: [],
      docCurrentPage: 1,
      docTotalPages: 0,
      isdocAddShow: false,
      docAdd_id: "",
      doctorArr: [],
      doc_studio_id: 0,
      isBatchAddShow: false,
      doctor_ids: [],
    };
  },
  created() {
    this.getinit();
  },
  methods: {
    saveSortData() {
      this.doctor_ids = [];
      for (let i = 0; i < this.studioDoctorArr.length; i++) {
        this.doctor_ids.push(this.studioDoctorArr[i].id);
      }
      let params = {
        doctor_ids: this.doctor_ids.toString(),
      };
      http
        .put("/admin/studios/" + this.doc_studio_id + "/doctors/order", params)
        .then((res) => {
          if (res.data.status_code == 200) {
            this.$message.success("保存成功");
            this.studioDoctorlist(this.doc_studio_id);
          } else {
            this.$message.error(res.data.msg);
          }
        });
      console.log(this.doctor_ids.toString(), "str");
    },
    // 拖拽
    initSortTable() {
      // 获取 el-table
      const tableTag = this.$refs["windowMultipleTable"].$el;
      // 获取 tbody 节点
      const elTbody = tableTag.querySelectorAll(
        ".el-table__body-wrapper > table > tbody"
      )[0];
      // 拖拽排序
      this.sortable = Sortable.create(elTbody, {
        onEnd: (evt) => {
          const tempIndex = this.studioDoctorArr.splice(evt.oldIndex, 1)[0];
          this.studioDoctorArr.splice(evt.newIndex, 0, tempIndex);
          console.log(this.studioDoctorArr, "studioDoctorArr");
        },
      });
    },
    //   列表
    getinit() {
      this.loading = true;
      let params = {
        page: this.currentPage,
        page_size: 10,
      };
      if (this.keywords) {
        params["keywords"] = this.keywords;
      }
      http.get("/admin/studios", { params }).then((res) => {
        if (res.data.status_code == 200) {
          this.totalPages = res.data.data.total_pages;
          this.currentPage = res.data.data.page;
          this.page_index = (this.currentPage - 1) * 10;
          this.studiosArr = res.data.data.items;
          //   console.log(this.studiosArr);
          this.loading = false;
        }
      });
    },
    // 详情
    studioDetails(item, num) {
      //   console.log(item);
      let url = "/admin/studios/" + item.id;
      http.get(url).then((res) => {
        if (res.data.status_code == 200) {
          if (num == 1) {
            this.studioDetailArr = res.data.data;
            this.isDetailShow = true;
          } else {
            this.studioModifyArr = res.data.data;
            this.isModifyShow = true;
            this.isPut = true;
            this.studioModifyArr.built_up_date = new Date(
              this.studioModifyArr.built_up_date * 1000
            );
          }
        }
      });
    },
    // 删除
    deleteStudio(item) {
      let url = "/admin/studios/" + item.id;
      http.delete(url).then((res) => {
        if (res.data.status_code == 200) {
          this.getinit();
          this.$message.success("删除成功");
        }
      });
    },
    // 新增按钮
    addStudioBtn() {
      this.studioModifyArr = {
        name: "",
        introduce: "",
        avatar_path: "",
        avatar: "",
        built_up_date: new Date(),
      };
      this.isModifyShow = true;
      this.isPut = false;
    },
    // 新增
    addStudio() {
      console.log(this.studioModifyArr);
      // Date.parse(new Date()) / 1000
      let url = "admin/studios/";
      let params = {
        name: this.studioModifyArr.name,
        introduce: this.studioModifyArr.introduce,
        avatar_path: this.studioModifyArr.avatar_path,
        built_up_date: Date.parse(this.studioModifyArr.built_up_date) / 1000,
      };
      console.log(params);
      http.post(url, params).then((res) => {
        console.log(res);
        if (res.data.status_code == 200) {
          this.studioModifyArr = {};
          this.isModifyShow = false;
          this.getinit();
          this.$message.success("新增工作室成功");
        }
      });
    },
    // 修改
    putStudioDetails() {
      // Date.parse(new Date()) / 1000
      let url = "admin/studios/" + this.studioModifyArr.id;
      let params = {
        name: this.studioModifyArr.name,
        introduce: this.studioModifyArr.introduce,
        avatar_path: this.studioModifyArr.avatar_path,
        built_up_date: Date.parse(this.studioModifyArr.built_up_date) / 1000,
      };
      http.put(url, params).then((res) => {
        if (res.data.status_code == 200) {
          this.studioModifyArr = {};
          this.isModifyShow = false;
          this.getinit();
          this.$message.success("修改成功");
        }
      });
    },
    // 工作室医生
    docHandlePageChange(val) {
      this.docCurrentPage = val;
      this.studioDoctorlist(this.doc_studio_id);
    },
    // 列表
    studioDoctorlist(id) {
      //   console.log(item);
      this.doc_studio_id = id;
      this.doc_loading = true;
      let params = {
        page: this.docCurrentPage,
        page_size: 10,
      };
      let url = "/admin/studios/" + id + "/doctors";
      http.get(url, { params }).then((res) => {
        if (res.data.status_code == 200) {
          this.isStudioDoctorShow = true;
          this.studioDoctorArr = res.data.data.items;
          this.docCurrentPage = res.data.data.page;
          this.docTotalPages = res.data.data.total_pages;
          this.doc_loading = false;
          this.$nextTick(() => {
            this.initSortTable();
          });
          console.log(this.studioDoctorArr);
        }
      });
    },
    addStudioDoctorlist() {
      let params = {
        page: this.doc_currentPage,
        page_size: 1000,
      };
      http.get("/admin/doctors", { params }).then((res) => {
        // console.log(res)
        if (res.data.status_code == 200) {
          this.doctorArr = res.data.data.items;
          console.log(this.doctorArr);
          this.isdocAddShow = true;
        }
      });
    },
    // 查询工作室医生
    searchStudioDoctor() {
      let params = {
        keywords: this.searchKeywords,
      };
      http.get("/admin/doctors/filter", { params }).then((res) => {
        if (res.data.status_code == 200) {
          this.studioDoctorTableData = res.data.data;
        }
      });
    },
    // 选择工作室医生
    handleCurrentChange(e) {
      this.docAdd_id = e.id;
    },
    selectHandle(val) {
      console.log(val);
    },
    // 新增
    addStudioDoctor() {
      // console.log(this.docAdd_id)
      let url = `/admin/studios/${this.doc_studio_id}/doctors/${this.docAdd_id}`;
      let params = {
        doctor_id: this.docAdd_id,
      };
      http.post(url, params).then((res) => {
        if (res.data.status_code == 200) {
          this.doctorArr = {};
          this.isdocAddShow = false;
          this.studioDoctorlist(this.doc_studio_id);
          this.$message.success("新增工作室医生成功");
        }
      });
    },
    // 删除
    deleteStudioDoctor(id) {
      console.log(id);
      let url = `/admin/studios/${this.doc_studio_id}/doctors/${id}`;
      http.delete(url).then((res) => {
        if (res.data.status_code == 200) {
          this.studioDoctorlist(this.doc_studio_id);
          this.$message.success("删除成功");
        }
      });
    },
    formatDate(time) {
      return new Date(time * 1000).Format("YYYY-MM-DD hh:mm:ss");
    },
    onInput() {
      this.$forceUpdate();
    },
    // 上传
    beforeAvatarUpload(file) {
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        var filename = file.name.split(".")[0] + "." + imgType;
        ossData.append("work_path", "studio/avatar");
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        that.$forceUpdate();
        http2.post("upload", ossData).then(function(res) {
          if (res.data.status_code == 200) {
            that.studioModifyArr.avatar_path = "studio/avatar/" + filename;
            that.studioModifyArr.avatar = URL.createObjectURL(file);
            that.$forceUpdate();
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    downloadStudiosFile() {
      let params = {
        type: 1,
      };
      http.get("/admin/excel/template", { params }).then((res) => {
        window.location.href = res.data.data.template_url;
      });
    },
    batchCreationStudios(file) {
      const isZip = file.type === "application/x-zip-compressed";
      if (isZip) {
        var ossData = new FormData();
        ossData.append("excel", file);
        this.uploading = true;
        http.post("/admin/studios", ossData).then((res) => {
          if (res.data.status_code == 200) {
            this.isBatchAddShow = false;
            this.$message.success("批量添加工作室及其医生成功");
          }
          this.uploading = false;
        });
      } else if (!isZip) {
        this.$message.error("上传文件不是zip文件");
      }
      return isZip;
    },
  },
};
</script>

<style scoped>
.handle-box {
  margin-bottom: 20px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  width: 300px;
  display: inline-block;
}
.handle-input2 {
  width: 380px;
  display: inline-block;
}
.table {
  width: 100%;
  font-size: 14px;
}
.red {
  color: #ff0000;
}
.mr10 {
  margin-right: 10px;
}
.table-td-thumb {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}
.self-dialog-footer {
  display: block;
  text-align: center;
}
.avatar {
  height: 178px;
  line-height: 178px;
  display: block;
  max-width: 100%;
  text-align: center;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.look-thumb {
  display: block;
  width: 178px;
}
</style>
